import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { GOODS_TYPES } from 'constants/sales'
import { US } from 'constants/countries'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { ResizeContext } from 'contexts/Resize'
import { LastBlock } from 'styles/components/layout'
import HeaderPad from 'modules/DnaAbout/components/HeaderPad'
import { OrderTestWidget } from 'widgets/OrderTestWidget'

import BNutritionDiet from './components/BNutritionDiet'
import BNutritionFirstBlock from './components/BNutritionFirstBlock'
import BNutritionHowCanHelp from './components/BNutritionHowCanHelp'
import BNutritionQuestions from './components/BNutritionQuestions/BNutritionQuestions'
import { BNutritionBanner } from './components/BNutritionBanner'
import { BKeyFactors } from './components/BKeyFactors'
import { BDiet } from './components/BDiet'
import { BGutHealth } from './components/BGutHealth'
import { BReligion } from './components/BReligion'
import { BYoutube } from './components/BYoutube'

class BiomeNutrition extends Component {
  scrollToRef = React.createRef()

  render() {
    const { texts } = this.props
    const viewport = this.context
    const isUs = this.props.locale === US

    return (
      isUs ? (
        <>
          <HeaderPad />
          <BNutritionBanner texts={texts.banner} />

          <BKeyFactors texts={texts.key_factors} />

          <BDiet texts={texts.diet_new} />

          <BGutHealth texts={texts.gut_health} />

          <BReligion texts={texts.religion} />

          <BYoutube texts={texts.youtube} />

          <OrderTestWidget
            className='pb-md-6'
            productType={GOODS_TYPES.biome}
            commonTexts={texts}
          />
        </>
      ) : (
        <>
          <BNutritionFirstBlock
            scrollToElement={this.scrollToRef}
            data={texts.first}
          />
          <div ref={this.scrollToRef}>
            <BNutritionDiet data={texts.diet} />
          </div>

          <BNutritionHowCanHelp data={texts.how_we_help} />

          <BNutritionQuestions
            isMobile={viewport.mobile}
            data={texts.how_can_change}
          />

          <LastBlock>
            <CartSaleWideContainer
              className='pt-2 pt-md-6'
              productType={GOODS_TYPES.biome}
            />

            <DistributionBannerContainer />
          </LastBlock>
        </>
      )
    )
  }
}

BiomeNutrition.contextType = ResizeContext

BiomeNutrition.propTypes = {
  texts: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
}

export default BiomeNutrition
